export default __webpack_public_path__ + "static/media/Mac-app.b34e3601.png";